import clsx from "clsx";

export type GridTableElement = {
  cellOne: string;
  cellTwo: string;
  className?: string;
};

export interface GridTableProps {
  gridContent: GridTableElement[];
  gridHeaders: [string, string];
}

export const GridTable = ({ gridHeaders, gridContent }: GridTableProps) => {
  const lastRowPosition = gridContent.length - 1;

  const baseStyles = "px-4 py-2.5 text-[12px]";
  const cellOneBorders = "border-b border-r border-b-gray-100 col-span-2";
  const cellTwoBorders = "border-b border-b-gray-100";
  const lastCellOneBorders = "border-r border-r-gray-100 col-span-2";

  return (
    <div className="grid grid-cols-3 border border-gray-100 rounded text-[16px] overflow-hidden">
      <span className="bg-gray-50 border-b border-r border-b-gray-100 px-4 py-2.5 text-[13px] sm:text-[16px] col-span-2 font-bold">
        {gridHeaders[0]}
      </span>
      <span className="bg-gray-50 border-b border-b-gray-100 px-4 py-2.5 text-[13px] sm:text-[16px] font-bold">
        {gridHeaders[1]}
      </span>
      {gridContent.map((row: GridTableElement, index) => {
        return (
          <>
            {lastRowPosition === index ? (
              <>
                <span className={clsx(baseStyles, lastCellOneBorders)}>{row.cellOne}</span>
                <span className={clsx(baseStyles)}>{row.cellTwo}</span>
              </>
            ) : (
              <>
                <span className={clsx(baseStyles, cellOneBorders, row.className)}>
                  {row.cellOne}
                </span>
                <span className={clsx(baseStyles, cellTwoBorders, row.className)}>
                  {row.cellTwo}
                </span>
              </>
            )}
          </>
        );
      })}
    </div>
  );
};
